<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Reporte '{{this.parametrosPrincipal.nombreConsulta}}'</h2>
            <p>{{this.parametrosPrincipal.descripcionConsulta}}</p>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between filtrosTable align-items-center">
        <div class="d-flex justify-content-start">
            <div class="p-1">
                <h2>Filtrar reporte</h2>
            </div>
            <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
                <div class="p-1" *ngFor="let item of listParametrosPrincipal">
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'TEXTO' || item.parametro.tipoParametro === 'NUMERO'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <input matInput [formControlName]="item.parametro.nombreParametro" autocomplete="off" (keyup.enter)="ConsultarInformacion()">
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'FECHA'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="item.parametro.nombreParametro" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'LISTA'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <mat-select [formControlName]="item.parametro.nombreParametro">
                            <mat-option [value]="item.id" *ngFor="let item of item.valoresSeleccion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'LOGICO'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <mat-select [formControlName]="item.parametro.nombreParametro">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaComboSINO">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row-reverse">
            <div class="p-1">
                <button title="Exportar datos" (click)="ExportarConsulta()" mat-icon-button matSuffix type="button" class="accesoAdd mt-0" *ngIf="mostrarResultadoConsulta" [disabled]="mostrarCargando">
                    <mat-icon>archive</mat-icon>
                </button>
            </div>
            <div class="p-1">
                <button (click)="ConsultarInformacion()" mat-icon-button matSuffix type="button" class="accesoAdd mt-0" [disabled]="mostrarCargando">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between filtrosTable align-items-center" autocomplete="off">
        <div class="d-flex justify-content-start">
            <div class="p-1">
                <h2>Otros filtros</h2>
            </div>
            <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
                <div class="p-1" *ngFor="let item of listParametrosSecundario">
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'TEXTO' || item.parametro.tipoParametro === 'NUMERO'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <input matInput [formControlName]="item.parametro.nombreParametro" autocomplete="off" (keyup.enter)="ConsultarInformacion()">
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'FECHA'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="item.parametro.nombreParametro" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'LISTA'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <mat-select [formControlName]="item.parametro.nombreParametro">
                            <mat-option [value]="item.id" *ngFor="let item of item.valoresSeleccion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" *ngIf="item.parametro.tipoParametro === 'LOGICO'">
                        <mat-label>{{item.parametro.descripcionParametro}}{{item.parametro.requerido ? '*':''}}</mat-label>
                        <mat-select [formControlName]="item.parametro.nombreParametro">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaComboSINO">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="this.form.get(item.parametro.nombreParametro).hasError('required')">{{item.parametro.descripcionParametro}} es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row-reverse">
            <div *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.parametrosPrincipal.columnaTotalizar)">
                <mat-form-field appearance="fill">
                    <mat-label>Valor total</mat-label>
                    <input matInput [value]="ValorNumericoVisualizar()" autocomplete="off">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="pl-0 pr-0 mat-elevation-z8">
        <div class="table-responsive">
            <mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <ng-container [matColumnDef]="item" *ngFor="let item of columnasEncabezado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{item}}</th>
                    <td mat-cell *matCellDef="let row">
                        {{VerificarColumnaFormatoEspecial(item, row[item])}}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </mat-table>
        </div>
    </div>
    <div class="fondopaginador">
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>